<template>
    <ion-button
        class="fix-button inherit-color"
        :class="{ 'inherit-color inherit-border-color': fill === BUTTON_FILL.OUTLINE }"
        :button-type="buttonType"
        :color="color"
        :disabled="disabled"
        :download="download"
        :expand="expand"
        :fill="fill"
        :href="href"
        mode="ios"
        :rel="rel"
        :router-animation="routerAnimation"
        :router-direction="routerDirection"
        :shape="shape"
        :size="size"
        :strong="strong"
        :target="target"
        :type="type"
        @ionBlur="$emit('blur')"
        @ionFocus="$emit('focus')"
    >
        <div slot="start" class="center" v-if="$slots['start']">
            <slot name="start"/>
        </div>

        <slot/>

        <div slot="end" class="center" v-if="$slots['end']">
            <slot name="end"/>
        </div>

        <div slot="icon-only" v-if="$slots['icon-only']">
            <slot name="icon-only"/>
        </div>

        <ion-icon v-if="arrow" :icon="chevronForward" class="inherit-color button-arrow icon-arrow"/>
    </ion-button>
</template>

<script setup lang="ts">
import { IonButton, IonIcon } from "@ionic/vue";

import { BUTTON_FILL, BUTTON_TYPE, ION_ROUTER_DIRECTION, ION_VARIANT } from "@/types/enum/ionicEnum";
import { IonButtonProps } from "@/types/props";
import { IonButtonEmits } from "@/types/emits";

import { chevronForward } from "ionicons/icons";

withDefaults(defineProps<IonButtonProps>(), {
    buttonType: BUTTON_TYPE.BUTTON,
    disabled: false,
    routerDirection: ION_ROUTER_DIRECTION.FORWARD,
    strong: false,
    type: BUTTON_TYPE.BUTTON,
    color: ION_VARIANT.CORAL
})

defineEmits<IonButtonEmits>()
</script>

<style scoped>
.fix-button.button-outline.ion-activated::part(native)::after {
    opacity: .4;
}

.fix-button.inherit-color::part(native) {
    color: inherit;
}

.fix-button.inherit-border-color::part(native) {
    border-color: var(--color);
}

.button-arrow {
    position: absolute;
    right: -8px;
}
</style>

<style scoped lang="scss">
@use '@/theme/mixin.scss';

.fix-button {
    border-radius: 5em;
    --border-radius: 5em;
    width: 240px;
    isolation: isolate;
    height: 55px;

    @include mixin.light {
        box-shadow: var(--light-shadow);
    }

    @include mixin.dark {
        box-shadow: none;
    }
}

.fix-button.button-outline.ion-activated::part(native)::after {
    @include mixin.light {
        color: inherit;
    }

    @include mixin.dark {
        color: var(--color)
    }
}
</style>
